import { usePrevious } from '@mantine/hooks'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'

import { hasNavigatedAtom } from '@/global-state'
import { usePathname } from '@/i18n-routing'
import { getStore } from '@/store'

export const UseSetUpHasNavigatedState = () => {
	const pathname = usePathname()
	const prevPathname = usePrevious(pathname)

	const setHasNavigated = useSetAtom(hasNavigatedAtom)

	useEffect(() => {
		if (prevPathname && !getStore().get(hasNavigatedAtom)) {
			setHasNavigated(true)
		}
	}, [prevPathname, setHasNavigated])

	return null
}
